export function item(state) {
  return state.item
}

export function items(state) {
  return state.items
}

export function pagination(state) {
  return state.pagination
}

export function widthMeasures(state) {
  return state.widthMeasures
}

export function heightMeasures(state) {
  return state.heightMeasures
}

export function rimMeasures(state) {
  return state.rimMeasures
}

export function brands(state) {
  return state.brands
}

export function models(state) {
  return state.models
}

export function years(state) {
  return state.years
}

export function version(state) {
  return state.version
}

export function vehicle(state) {
  return state.vehicle
}
